
import React from 'react';
import { Button } from "@/components/ui/button";
import ExcelUpload from '@/components/ExcelUpload';

interface UploadControlsProps {
  onDataLoaded: (data: any[]) => void;
  onClearTable: () => void;
  hasData: boolean;
}

const UploadControls: React.FC<UploadControlsProps> = ({
  onDataLoaded,
  onClearTable,
  hasData
}) => {
  return (
    <div className="flex justify-between items-center gap-4">
      <ExcelUpload onDataLoaded={onDataLoaded} />
      <Button 
        variant="destructive" 
        onClick={onClearTable}
        disabled={!hasData}
      >
        Clear Table
      </Button>
    </div>
  );
};

export default UploadControls;
